import { authPagePath } from "../auth/resume";
import { usePartnerStore } from "../store/usePartnerStore";
import { useSessionStore } from "../store/useSessionStore";
import { useRouteWithToken } from "./useRouteWithToken";

const isValidHttpUrl = (url: string): boolean =>
  url.startsWith("http://") || url.startsWith("https://");

/**
 * Exit CTAs: live-link Return to app uses envelope `callbackUrl`; dead-link
 * (410/409) uses partner `sessionExpiredRedirectUrl`. Neither is a webhook.
 *
 * Fund-request has no Landing page. Falling back to `/landing-page` matched
 * `/:linkId` with linkId=`landing-page` and surfaced a false "Link Expired".
 * Anonymous `/transactions-page` is forbidden.
 */
export const useExitToPartnerOrLanding = () => {
  const deadRedirectUrl = usePartnerStore((s) => s.sessionExpiredRedirectUrl);
  const liveCallbackUrl = useSessionStore((s) => s.session.data?.callbackUrl);
  const { redirectTo } = useRouteWithToken();

  const partnerDeadUrl =
    deadRedirectUrl && isValidHttpUrl(deadRedirectUrl)
      ? deadRedirectUrl
      : null;
  const partnerLiveUrl =
    liveCallbackUrl && isValidHttpUrl(liveCallbackUrl)
      ? liveCallbackUrl
      : null;

  const exitToPartnerOrLanding = () => {
    if (partnerLiveUrl) {
      window.location.href = partnerLiveUrl;
      return;
    }
    redirectTo(authPagePath({ kind: "transactions" }));
  };

  const exitToPartnerOnly = () => {
    if (partnerDeadUrl) {
      window.location.href = partnerDeadUrl;
    }
  };

  return {
    exitToPartnerOrLanding,
    exitToPartnerOnly,
    canExitToPartner: !!partnerDeadUrl,
    canExitLive: !!partnerLiveUrl,
    liveCallbackUrl: partnerLiveUrl,
  };
};
